<template>
<div>
    <Breadcrumbs main="Finance & Accounts" submain="Accounts" title="Requisition" />

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header header-mobile">
                        <router-link to="/finance-and-accounts/account/requisition/create/new">
                            <button class="btn btn-primary" type="submit" style="display: flex; align-items: center;">
                                <div style="display: flex; gap: 12px; align-items: center; color: white;">
                                    <i class="fa fa-light fa-plus"></i>
                                    <h7>Add New Requisition</h7>
                                </div>
                            </button>
                        </router-link>
                        <router-link to="/finance-and-accounts/account/requisition/type">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-solid fa-bars"></i>
                                <h7>Requisition Type</h7>
                            </button>
                        </router-link>
                    </div>
                   <div class="card-body">
                     <div class="row">
                        <div class="col-sm-6 col-md-3 col-xl-2 mb-2 mb-sm-0">
                            <div class="mini-box advance-box">
                                <p class="mini-label">Total Advance</p>
                                <h6 class="mini-value">৳ {{ advance }}</h6>
                            </div>
                        </div>

                        <div class="col-sm-6 col-md-3 col-xl-2">
                            <div class="mini-box settled-box">
                                <p class="mini-label">Total Settled</p>
                                <h6 class="mini-value">৳ {{ settled }}</h6>
                            </div>
                        </div>
                    </div>
                   </div>
                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="filter" placeholder="Type to Search" style="box-shadow: none;"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                    <feather type="filter"></feather>
                                    <h7>Filter</h7>
                                </div>
                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #B842B5; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="downloadCSV()">
                                    <h7 class="">Download CSV</h7>
                                </div>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="statusSelected || start_date || end_date || selectedDepartment ||selectedDesignation || selectedEmployee">
                                    <feather type="x"></feather>
                                    <h7>Clear All</h7>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="3" label="Per page" class="mb-0 w-100 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions" style="width: 100%;"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="row mt-2" v-if="filterShow">
                            <div class="col-md-12">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <datepicker placeholder="Start Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_date"></datepicker>
                                    </div>
                                    <div class="grid-item">
                                        <datepicker placeholder="End Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_date"></datepicker>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="statusSelected" :options="formattedOptions"></b-form-select>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="selectedType" :options="formattedType"></b-form-select>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-select v-model="selectedDepartment" :options="formattedDepartment"></b-form-select>
                                    </div>
                                    <div class="grid-item" v-if="selectedDepartment">
                                        <b-form-select v-model="selectedDesignation" :options="formattedDesignation"></b-form-select>
                                    </div>
                                    <div class="grid-item" v-if="selectedDesignation">
                                        <b-form-select v-model="selectedEmployee" :options="formattedEmployee"></b-form-select>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(requisition_id)="data">
                                        <span>
                                            <router-link :to="`/finance-and-accounts/account/requisition/view/${data.item.id}`" class="link-style">
                                                {{ data.item.requisition_id }}
                                            </router-link>
                                        </span>
                                    </template>

                                    <template #cell(title)="data">
                                        <span style="max-width: 250px;">
                                            {{ data.item.title }}
                                        </span>
                                    </template>

                                    <template #cell(raised_by)="data">
                                        <div class="d-flex flex-column">
                                            <span>
                                                <router-link :to="`/finance-and-accounts/account/requisition/view/${data.item.id}`" class="link-style">
                                                    {{ data.item.raised_by.first_name }} {{ data.item.raised_by.last_name }}
                                                </router-link>
                                            </span>
                                            <span>
                                                {{ formattedDate(data.item.created_at) }}
                                            </span>
                                        </div>
                                    </template>

                                    <template #cell(grand_total)="data">
                                        <!-- <span>
                                            {{ data.item.grand_total }}
                                        </span> -->
                                        <div class="d-flex flex-column" style="width: 150px;">
                                            <span class="font-weight-bold">Total: {{ data.item.grand_total }}</span>
                                            <span><span class="text-success font-weight-bold">Paid:</span> {{ data.item.paid_amount }}</span>
                                            <span><span class="text-danger font-weight-bold">Due:</span> {{ data.item.due_amount }}</span>
                                        </div>
                                    </template>

                                    <template #cell(refering_to)="data">
                                        <span>
                                            <div v-if="data.item.refering_to !== null && data.item.refering_to.length > 0">
                                                <div class="customers">
                                                    <ul>
                                                        <ul v-for="(member, index) in data.item.refering_to.slice(0,5)" :key="index">
                                                            <li v-if="member.photo" class="d-inline-block" v-b-tooltip.hover :title="member.full_name"><img class="rounded-circle img-30" :src="host + member.photo" alt="" data-original-title=""></li>
                                                            <li v-else class="d-inline-block" v-b-tooltip.hover :title="member.full_name"><img class="rounded-circle img-30" src="../../../assets/images/user/3.jpg" alt="" data-original-title=""></li>
                                                        </ul>
                                                        <li class="d-inline-block mr-2" v-if="data.item.refering_to.length > 5">
                                                            <p class="f-12">+ {{ data.item.refering_to.length - 5 }}</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <p>N/A</p>
                                            </div>
                                        </span>
                                    </template>

                                    <template #cell(status)="row">
                                        <!-- v-b-modal.modal-prevent-closing pill -->
                                        <span @click="getStatus(row.value, row.item.id)" v-if="row.value == 'APPROVED'" v-b-tooltip.hover :title="row.item?.approved_by?.full_name">
                                            <b-badge variant="success" v-b-modal.modal-prevent-closing pill>{{ row.value }}</b-badge>
                                        </span>
                                        <span @click="getStatus(row.value, row.item.id)" v-if="row.value == 'PENDING'">
                                            <b-badge variant="primary" v-b-modal.modal-prevent-closing pill>{{ row.value }}</b-badge>
                                        </span>
                                        <span @click="getStatus(row.value, row.item.id)" v-if="row.value == 'DUE'">
                                            <b-badge variant="warning" v-b-modal.modal-prevent-closing pill>{{ row.value }}</b-badge>
                                        </span>
                                        <span @click="getStatus(row.value, row.item.id)" v-if="row.value == 'REJECTED'">
                                            <b-badge variant="danger" v-b-modal.modal-prevent-closing pill>{{ row.value }}</b-badge>
                                        </span>

                                        <span v-if="row.value == 'SETTLED'">
                                            <b-badge pill variant="info">{{ row.value }}</b-badge>
                                        </span>
                                        <span v-if="row.value == 'UNSETTLED'">
                                            <b-badge pill variant="warning">{{ row.value }}</b-badge>
                                        </span>
                                    </template>

                                    <!-- <template #cell(settled_status)="row">
                                        <span  v-if="row.value == 'SETTLED'" >
                                            <b-badge pill variant="success">{{ row.value }}</b-badge>
                                        </span>
                                        <span v-if="row.value == 'UNSETTLED'">
                                            <b-badge pill variant="warning">{{ row.value }}</b-badge>
                                        </span>
                                        <span v-if="row.value == 'NOT_REQUIRED'">
                                            <b-badge pill variant="primary">NOT REQUIRED</b-badge>
                                        </span>
                                    </template> -->

                                    <template #cell(record)="data">
                                        <div @click="recordPayment(data)" v-if="data.item.status === 'APPROVED' && data.item.due_amount > 0">
                                            <b-badge variant="primary" v-b-modal.modal-record>Record Payment</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteRequisition(data.item.id)" title="Delete"></feather>
                                            <router-link :to="`/finance-and-accounts/account/requisition/view/${data.item.id}`">
                                                <feather type="eye" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="View"></feather>
                                            </router-link>
                                            <div>
                                                <feather type="message-circle" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-scrollable @click="Reply(data.item)" title="Reply"></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Requisition Status -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Update Requisition Status" @show="resetModal" @hidden="resetModal" @ok="handleStatusOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="selectedStatus" :options="statuses"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Requisition Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this requisition?</div>
    </b-modal>

    <!-- Record Payment -->
    <b-modal id="modal-record" ref="modal" title="Record Payment" @show="resetModal" @hidden="resetModal" @ok="handleRecordOk">
        <form ref="form" @submit.stop.prevent="handleRecordSubmit">
            <b-form-group label="Amount" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="record.paid_amount" placeholder="Enter Amount"></b-form-input>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Refer and Chat -->
    <b-modal id="modal-scrollable" ref="modal" title="Requsition Reply" hide-footer @hidden="resetModal" @ok="handleOk">
        <h6>Already Refered</h6>

        <div class="row">
            <div class="col-sm-6 text-center w-full" v-for="user in my_reply.refer_to" :key="user.id" v-b-tooltip.hover v-b-modal.modal-center-deleteAlocation @click="deletetAllocation(user.id)" title="Delete">
                <div class="mb-2 badge-style w-100">
                    <h7>{{ user.first_name}} {{ user.last_name }}</h7>
                    <b-icon icon="x" style="color: white;"></b-icon>
                </div>
            </div>
        </div>

        <multiselect v-model="assignedMembers" tag-placeholder="Add member" placeholder="Search or add a member" label="full_name" :max="user_list.length" :options="formattedUserList" track-by="id" :multiple="true" :taggable="true"></multiselect>

        <!-- v-if="eod_reply.length > 0" -->
        <div style="margin-top: 30px;">
            <h6>Replies</h6>

            <div class="task-board-comments">
                <div v-for="reply in req_replies" :key="reply.id" class="chatbox">
                    <div class="chat">
                        <div class="avatar">
                            <img :src="host + reply.replier_photo" alt="" v-b-tooltip.hover :title="reply.replied_by.first_name + ' ' + reply.replied_by.last_name">
                        </div>
                        <div class="message">
                            <h7 class="name pl-1">{{ reply.replied_by.username }}</h7>
                            <!-- <p class="msg" v-b-tooltip.hover :title="reply.reply_date">{{ reply.reply }}</p> -->
                            <p class="msg" v-html="convertUrls(reply.reply)"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="task-board-comment-box" style="margin-top: 10px;">
            <div style="display: flex; gap: 12px;">
                <input class="form-control" type="text" v-model="my_reply.reply" placeholder="Write your reply here..." @keyup.enter="handleReplySubmit()">
                <button @click="handleReplySubmit()" class="btn btn-primary">Send</button>
            </div>
        </div>
    </b-modal>

    <b-modal id="modal-center-deleteAlocation" centered hide-header @ok="handleAllocationDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to remove this refer?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import moment from "moment";
import Datepicker from 'vuejs-datepicker';
import {
    myHost
} from '../../../_helpers/host';
import Multiselect from 'vue-multiselect';
export default {
    components: {
        Datepicker,
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'requisition_id',
                    label: 'REQ-ID',
                    sortable: true
                },
                {
                    key: 'raised_by',
                    label: 'Requested By',
                    sortable: true
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'grand_total',
                    label: 'Amount',
                    sortable: true
                },
                {
                    key: 'refering_to',
                    label: 'Reffered To',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: false
                },

                {
                    key: 'record',
                    label: 'Record',
                    sortable: true,
                    class: 'text-center'
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            record: {
                paid_amount: '',
                requisition: '',
            },
            requisition_due: '',
            filter: null,
            filterShow: false,
            start_date: null,
            end_date: null,
            statusSelected: '',
            selectedDepartment: '',
            selectedDesignation: '',
            selectedEmployee: '',
            statuses_list: [{
                    id: 1,
                    name: 'Pending',
                    value: 'PENDING'
                },
                {
                    id: 2,
                    name: 'Approved',
                    value: 'APPROVED'
                },
                {
                    id: 3,
                    name: 'Due',
                    value: 'DUE',
                },
                {
                    id: 4,
                    name: 'Rejected',
                    value: 'REJECTED',
                },
            ],
            temp_id: '',
            assignedMembers: [],
            my_reply: {
                id: '',
                reply: '',
                refer_to: '',
            },
            initialLoad: true,
            delete_value: null,
            selectedStatus: null,
            update_id: null,
            statuses: ['DUE', 'PENDING', 'APPROVED', 'REJECTED'],
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            isModifyingDate: false,
            selectedType: '',

            filterDebounceTimer: null,

        };
    },

    computed: {
        ...mapState({
            items: state => state.requisition.requisition,
            count: state => state.requisition.requisition_count,
            advance: state => state.requisition.reqAdvance,
            settled: state => state.requisition.reqSettled,
            loading: state => state.requisition.submitLoading,
            error: state => state.requisition.submitError,
            department_list: state => state.department.departments,
            designation_list: state => state.department.designation_by_department,
            employee_list: state => state.department.employee_by_designation,
            req_replies: state => state.requisition.req_reply,
            user_list: state => state.employee.employee_list,
            req_type: state => state.requisition.requisition_type,
        }),

        formattedOptions() {
            return [{
                    value: '',
                    text: 'Select Status',
                    disabled: true
                },
                ...this.statuses_list.map(status => ({
                    value: status.value,
                    text: status.name
                }))
            ];
        },

        formattedUserList() {
            return this.user_list.map(user => ({
                ...user,
                full_name: `${user.first_name} ${user.last_name}`
            }));
        },

        formattedEmployee() {
            return [{
                    value: '',
                    text: 'Select Employee',
                    disabled: true
                },
                ...this.employee_list.map(emp => ({
                    value: emp.id,
                    text: emp.full_name
                }))
            ];
        },

        formattedDesignation() {
            return [{
                    value: '',
                    text: 'Select Designation',
                    disabled: true
                },
                ...this.designation_list.map(desg => ({
                    value: desg.id,
                    text: desg.title
                }))
            ];
        },

        formattedDepartment() {
            return [{
                    value: '',
                    text: 'Select Department',
                    disabled: true
                },
                ...this.department_list.map(dept => ({
                    value: dept.id,
                    text: dept.name
                }))
            ];
        },
        formattedType() {
            return [{
                    value: '',
                    text: 'Select Requisition Type',
                    disabled: true
                },
                ...this.req_type.map(type => ({
                    value: type.id,
                    text: type.name
                }))
            ];
        },

    },

    watch: {
        filter(newVal, oldVal) {
    if (!this.initialLoad) {
        clearTimeout(this.filterDebounceTimer);
        this.filterDebounceTimer = setTimeout(() => {
            this.$store.dispatch("requisition/fetchRequisition", {
                perPage: this.perPage,
                currentPage: 1,
                start_date: this.start_date,
                end_date: this.end_date,
                status: this.statusSelected,
                search_term: newVal,
                raised_by: this.selectedEmployee,
                req_type: this.selectedType
            }).then(() => {
                this.currentPage = 1;
                this.totalRows = this.count;
            });
        }, 400);
    }
},

        assignedMembers: {
            handler: function (newVal, oldVal) {
                this.storeAssignedMembers(newVal);
            },
            deep: true
        },

        selectedDepartment(newVal, oldVal) {
            this.$store.dispatch("department/fetchDesignationByDepartment", newVal)
        },

        selectedDesignation(newVal, oldVal) {
            this.$store.dispatch("department/fetchEmployeeByDesignation", newVal)
        },

        statusSelected(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("requisition/fetchRequisition", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },
        selectedType(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("requisition/fetchRequisition", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        selectedEmployee(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("requisition/fetchRequisition", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                }).then(() => {
                    this.currentPage = 1
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }

        },

        start_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.start_date !== null) {
                        this.start_date = moment(String(this.start_date)).format("YYYY-MM-DD");
                        this.$store.dispatch("requisition/fetchRequisition", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            status: this.statusSelected,
                            search_term: this.filter,
                            raised_by: this.selectedEmployee,
                            req_type: this.selectedType
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    } else {
                        this.$store.dispatch("requisition/fetchRequisition", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            status: this.statusSelected,
                            search_term: this.filter,
                            raised_by: this.selectedEmployee,
                            req_type: this.selectedType
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    }
                }

            }

        },

        end_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.end_date !== null) {
                        this.end_date = moment(String(this.end_date)).format("YYYY-MM-DD");
                        this.$store.dispatch("requisition/fetchRequisition", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            status: this.statusSelected,
                            search_term: this.filter,
                            raised_by: this.selectedEmployee,
                            req_type: this.selectedType
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    } else {
                        this.$store.dispatch("requisition/fetchRequisition", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            status: this.statusSelected,
                            search_term: this.filter,
                            raised_by: this.selectedEmployee,
                            req_type: this.selectedType
                        }).then(() => {
                            this.currentPage = 1
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    }
                }

            }

        },

        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/finance-and-accounts/account/requisition/list',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("requisition/fetchRequisition", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/finance-and-accounts/account/requisition/list',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });
                this.perPage = newperPage
                this.$store.dispatch("requisition/fetchRequisition", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },
        
    },

    mounted() {
        this.$store.dispatch("employee/fetchEmployeeList");
        this.$store.dispatch("department/fetchDepartments");
        this.$store.dispatch("requisition/fetchRequisitionType")
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {

                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });

                this.fetchInitial();
            } else {

                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);

                this.fetchInitial();
            }
        }

    },

    methods: {
        convertUrls(text) {
            if (text === null) {
                return '';
            }
            const urlPattern = /(https?:\/\/[^\s<]+)/g;
            return text.replace(urlPattern, (url) => {
                return `<a href="${url}" target="_blank" class="text-primary">${url}</a>`;
            });
        },
        fetchInitial() {
            this.$store.dispatch("requisition/fetchRequisition", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                start_date: this.start_date,
                end_date: this.end_date,
                status: this.statusSelected,
                search_term: this.filter,
                raised_by: this.selectedEmployee,
                req_type: this.selectedType
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },
        clearFilter() {
            this.filterShow = false,
                this.filter = null,
                this.statusSelected = '',
                this.start_date = null,
                this.end_date = null,
                this.selectedDepartment = '',
                this.selectedDesignation = '',
                this.selectedEmployee = ''
        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        formattedDate(dateString) {
            return moment(dateString).format('YYYY-MM-DD');
        },

        recordPayment(data) {
            this.record.requisition = data.item.id
            this.requisition_due = data.item.due_amount
        },

        resetModal() {
            this.record.paid_amount = ''
        },

        handleRecordOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleRecordSubmit()
        },

        handleRecordSubmit() {
            if (this.record.paid_amount > this.requisition_due) {
                Swal.fire({
                    title: "Error!",
                    text: 'Request amount is more than due amount!',
                    icon: "error"
                });
            } else {
                this.$store.dispatch("requisition/recordPayment", this.record).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.record.paid_amount = '',
                            this.record.requisition = ''

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })

                // Hide the modal manually
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-record')
                })
            }

        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        deleteRequisition(id) {
            this.delete_value = id
        },

        getStatus(status, id) {
            this.update_id = id
            this.selectedStatus = status
            // console.log(status, id)
        },

        handleStatusOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("requisition/updateRequisitionStatus", {
                id: this.update_id,
                status_for_change: this.selectedStatus,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                start_date: this.start_date,
                end_date: this.end_date,
                status: this.statusSelected,
                search_term: this.filter,
                raised_by: this.selectedEmployee

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        handleDeleteOk() {
            this.$store.dispatch("requisition/deleteRequisition", {
                delete: this.delete_value,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                start_date: this.start_date,
                end_date: this.end_date,
                status: this.statusSelected,
                search_term: this.filter,
                raised_by: this.selectedEmployee
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        Reply(type) {
            this.my_reply.id = type.id
            this.my_reply.reply = type.name
            this.my_reply.refer_to = type.refering_to
            this.$store.dispatch("requisition/fetchReqReply", this.my_reply.id)
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleReplySubmit()
        },

        handleReplySubmit() {
            if (this.my_reply.reply) {
                this.$store.dispatch("requisition/addReqReply", {
                    req: this.my_reply.id,
                    reply: this.my_reply.reply
                }).then(response => {

                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        // this.my_reply.id = '',
                        this.my_reply.reply = ''

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })

                // this.$nextTick(() => {
                //     this.$bvModal.hide('modal-scrollable')
                // })
            }
        },

        storeAssignedMembers(assignedMembers) {
            const latestId = assignedMembers[assignedMembers.length - 1].id;

            this.$store.dispatch("requisition/RequisitionAddRefer", {
                id: this.my_reply.id,
                refer_id: latestId,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                start_date: this.start_date,
                end_date: this.end_date,
                status: this.statusSelected,
                raised_by: this.selectedEmployee,
                allReq: true
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedMembers = '';

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable')
            })
        },

        deletetAllocation(id) {
            this.temp_id = id
        },

        handleAllocationDeleteOk() {

            this.$store.dispatch("requisition/RequisitionDeleteRefer", {
                id: this.my_reply.id,
                refer_id: this.temp_id,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                start_date: this.start_date,
                end_date: this.end_date,
                status: this.statusSelected,
                raised_by: this.selectedEmployee,
                allReq: true
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedMembers = '';

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable')
            })
        },

        downloadCSV() {
            this.$store.dispatch("requisition/fetchRequisitionCSV", {
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.statusSelected,
                    search_term: this.filter,
                    raised_by: this.selectedEmployee,
                    req_type: this.selectedType
                })
                .then(response => {

                    const blob = new Blob([response.data], {
                        type: 'text/csv'
                    });

                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'requisition.csv');
                    document.body.appendChild(link);
                    link.click();

                    link.remove();
                    URL.revokeObjectURL(url);

                    // Swal.fire({
                    //     title: "Success!",
                    //     text: "CSV downloaded successfully",
                    //     icon: "success"
                    // });
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to download CSV",
                        icon: "error"
                    });
                });

        }

    }
};
</script>

<style scoped>
.header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 460px) {
    .header-mobile {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: start;
    }
}

.img-30 {
    width: 30px !important;
    height: 30px !important;
}

.badge-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.375rem 1.75rem;
    color: white;
}

.badge-style:hover {
    background-color: #ff595d;
}

.chatbox {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 0px 10px;
}

.chat {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    word-break: break-all;
}

.avatar img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: solid 2px white;
}

.message {
    flex-grow: 1;
}

.msg {
    background: #fff0f0;
    width: 100%;
    /* Ensures message takes full width */
    padding: 10px;
    border-radius: 10px;
    position: relative;
    font-size: 13px;
    word-break: break-all;
}

.task-board-comments {
    height: 450px;
    overflow-y: auto;
}

/* height */
::-webkit-scrollbar {
    height: 6px;
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.mini-box{
    padding: 5px 10px;
    border-radius: 8px;
    transition: 0.3s ease;
}
.mini-box:hover {
  transform: translateY(-3px);
}
.advance-box .mini-label{
    font-size: 14px;
    color: #c4a50f;
    font-weight: 600;
}
.settled-box .mini-label{
    font-size: 14px;
    color: #388616b9;
    font-weight: 600;
}

.mini-box.advance-box{
    background: #f8d62b2c;
}

.mini-box.settled-box{
    background: #66c23e36;
}
</style>
